import templateUrl from 'emun.customer/cleanup/customer-cleanup-prompt.htm'
import CustomerCleanupPromptController from 'emun.customer/cleanup/customer-cleanup-prompt.controller'
//import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

const CustomerCleanupPrompt = {
	open(options) {
		console.debug("BL*** options", options);
		return modals.open(angular.extend({
			size: 'xl',
			templateUrl,
			resolve: {
				options: () => options
			},
			bindToController: true,
			controller: CustomerCleanupPromptController,
			controllerAs: '$ctrl'
		}, (options || {}).modal)).result;
	}
};

export default CustomerCleanupPrompt;